/* eslint-env browser */

'use strict'

const debug = require('debug')('wallet-add-chain')
const noop = Function.prototype

const addChain = function (params, callback = noop) {
  const {
    chainId,
    blockExplorerUrls,
    chainName,
    nativeCurrency,
    // According to the docs, Metamask is ignoring iconUrls https://docs.metamask.io/guide/rpc-api.html#other-rpc-methods
    // but it is part of of the spec in https://eips.ethereum.org/EIPS/eip-3085
    // iconUrls,
    rpcUrls
  } = params

  // If not running in a browser, error out.
  if (!window) {
    callback(new Error('Only browser environments are supported'))
    return
  }

  if (!chainId) {
    callback(new Error('chainId parameter must be specified'))
    return
  }

  const { ethereum } = window
  // The only wallet known for supporting EIP-3085 so far is MetaMask.
  // @ts-ignore ts(2339)
  if (!ethereum || !ethereum.isMetaMask) {
    callback(new Error('Wallet not supported'))
    return
  }

  const key = `addingChainId-${chainId}`
  if (window.localStorage.getItem(key)) {
    callback()
    return
  }
  ethereum
    .request({
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId,
          chainName,
          nativeCurrency,
          rpcUrls,
          blockExplorerUrls
        }
      ]
    })
    .then(function () {
      window.localStorage.setItem(key, true)
      debug('%s added to the wallet', chainId)
      callback()
    })
    .catch(function (err) {
      debug('Failed: %s', err.message)
      callback(err)
    })
}

module.exports = addChain
